import React from 'react';
import { Workspace } from 'app/views/components/editor/Workspace';
import { Controller } from './Controller';
export const Editor = () => (React.createElement(Workspace, null,
    React.createElement(Controller, null)));
